import LinkedToCustomerTask from "./LinkedToCustomerTask";
import NotLinkedToCustomerTask from "./NotLinkedToCustomerTask";

function Overview() {
	return (
		<div>
			<LinkedToCustomerTask />
		</div>
	);
}

export default Overview;